import React from 'react'

import cx from 'classnames'

import styles from './Grid.module.scss'

export default function Grid({
  additionalClasses,
  singleRow,
  children,
}: React.PropsWithChildren<{ additionalClasses?: string; singleRow?: boolean }>) {
  return <ul className={cx(styles.Grid, { [styles.SingleRow]: singleRow }, additionalClasses)}>{children}</ul>
}
